import { Outlet, useParams } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import SnapshotSection from '_/common/components/layout/SnapshotSection';
import { SnapshotProvider, useSnapshotContext } from '_/contexts/SnapshotContext';
import DocumentTitle from '_/hooks/DocumentTitle';
import React, { ReactElement } from 'react';

function SelectedSnapshotContent(): ReactElement {
  const { selectedSnapshot, isLoading } = useSnapshotContext();
  const params = useParams({ strict: false }) as Partial<{
    projectSlug?: string;
    collectionSlug?: string;
    sourceSlug?: string;
  }>;

  DocumentTitle(`Snapshot :: ${location.pathname.split('/').pop()}`);

  // The snapshot is fetched by id alone, so any valid-but-unrelated source/collection/project
  // slug in the URL would otherwise still render it and falsely imply ownership. Treat a path
  // that doesn't match the snapshot's actual owner as not-found, like any other invalid slug.
  const ownerMismatch =
    !!selectedSnapshot &&
    (params.sourceSlug !== selectedSnapshot.source?.slug ||
      params.collectionSlug !== selectedSnapshot.source?.collection?.slug ||
      params.projectSlug !== selectedSnapshot.source?.collection?.project?.slug);

  return (
    <AsyncPageContainer isLoading={!selectedSnapshot || isLoading} notFound={ownerMismatch}>
      <Outlet />
    </AsyncPageContainer>
  );
}

function SelectedSnapshot(): ReactElement {
  return (
    <SnapshotProvider>
      <SnapshotSection>
        <SelectedSnapshotContent />
      </SnapshotSection>
    </SnapshotProvider>
  );
}

export default SelectedSnapshot;
